<template>
    <div>
        <SelectReleaseType
            v-if="ifLimitAlbumForShowStart == 1 && showService == 1"
            :visible.sync="visible"
            @onCancel="onCancel"
            @onSelect="onSelectReleaseType"
        ></SelectReleaseType>
        <el-dialog
            v-else
            :visible="visible"
            custom-class="issue-service-dialog"
            :append-to-body="true"
            :wrapper-closable="false"
            @close="onCancel"
            :show-close="false"
            width="460px"
        >
            <div class="issue-service">
                <!-- <div class="item">
                    <p class="title">试用版</p>
                    <p>认证签约后，可免费获得</p>
                    <b>
                        ￥0
                        <span>/年</span>
                    </b>
                    <el-button v-if="$store.getters.userState == 3" type="info" @click="toAlbum">免费试用</el-button>
                    <el-button v-else-if="$store.getters.userState == 4" type="primary" disabled>已试用</el-button>
                    <ul>
                        <li>
                            <label>全球发行</label>
                            单曲1首
                        </li>
                        <li>
                            <label>200+平台渠道</label>
                            单曲1首
                        </li>
                        <li>
                            <label>100%版税、版权</label>
                            单曲1首
                        </li>
                        <li>
                            <label>快速审核并上线</label>
                            <span class="el-icon-close color-danger"></span>
                        </li>
                        <li>
                            <label>1对1专享服务</label>
                            <span class="el-icon-close color-danger"></span>
                        </li>
                        <li>
                            <label>定时发布</label>
                            <span class="el-icon-close color-danger"></span>
                        </li>
                        <li>
                            <label>数据报表</label>
                            <span class="el-icon-close color-danger"></span>
                        </li>
                    </ul>
                </div> -->
                <div class="item active">
                    <p class="title">VIP</p>
                    <p>全年无限量发行</p>
                    <b>
                        ￥99
                        <span>/年</span>
                    </b>
                    <el-button @click="toPay" v-if="$store.getters.userState <= 2" type="base">认证并签约</el-button>
                    <el-button @click="toPay" v-else type="base">立即购买</el-button>
                    <ul>
                        <li>
                            <label>全球发行</label>
                            不限
                        </li>
                        <li>
                            <label>200+平台渠道</label>
                            不限
                        </li>
                        <li>
                            <label>100%版税、版权</label>
                            不限
                        </li>
                        <li>
                            <label>快速审核并上线</label>
                            <span class="el-icon-check color-theme"></span>
                        </li>
                        <li>
                            <label>1对1专享服务</label>
                            <span class="el-icon-check color-theme"></span>
                        </li>
                        <li>
                            <label>定时发布</label>
                            <span class="el-icon-check color-theme"></span>
                        </li>
                        <li>
                            <label>数据报表</label>
                            <span class="el-icon-check color-theme"></span>
                        </li>
                    </ul>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SelectReleaseType from './selectReleaseType.vue';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        albumId: {
            type: String,
            default: '',
        },
    },
    components: {SelectReleaseType},
    data() {
        return {
            albums: [],
            showService: 1, // 1、选择发行渠道拦截， 0、不拦截
        };
    },
    computed: {
        ifLimitAlbumForShowStart() {
            return this.$store.state.userData && this.$store.state.userData.ifLimitAlbumForShowStart;
        },
    },
    mounted() {
        this.fetchAlbums();
    },
    methods: {
        async fetchAlbums() {
            const res = await this.$request({
                url: '/album/view/list?pageNo=1&queryKeyType=1&status=0&queryValue=&contractNo=&pageSize=11',
            });
            const {state, msg, result} = res.data;
            if (!state) this.$message.error(msg || '请求失败');
            this.albums = result.result || [];
        },
        onCancel() {
            this.showService = 1;
            this.$emit('onCancel');
            this.$emit('update:visible', false);
        },
        toPay() {
            const {userState, goContractSigned} = this.$store.getters;
            if (userState == 1) return this.$contractRouter('/manage/contract/verify/fdd/step/1', 'url');
            if (userState == 2) return this.$contractRouter(goContractSigned, 'url');
            return this.$router.push('/manage/pay');
        },
        toAlbum() {
            // 如果专辑已经是专辑详情
            const {params} = this.$route;
            if (params && params.albumId) return this.$emit('onSubmit', true);
            // 以前的逻辑
            if (this.albums.length >= 1) {
                this.$router.push(`/manage/album/singleTrackInfo/info/${this.albums[0].id}`);
            } else {
                this.$router.push(`/manage/album/singleTrackInfo/add`);
            }
        },
        onSelectReleaseType(data) {
            if (data == 1) {
                //选择仅秀动发行 直接通过
                this.$emit('onPass');
                this.onCancel();
            } else {
                this.showService = 0;
            }
        },
    },
};
</script>
<style lang="scss">
@keyframes zoom {
    0% {
        transform: scale(0.96);
        /* 初始大小 */
    }

    100% {
        transform: scale(1.06);
        /* 最终大小 */
    }
}

.issue-service-dialog {
    background: transparent;
    box-shadow: none;

    .issue-service {
        display: flex;

        .item {
            background: $--color-white;
            padding: 50px 30px;
            margin: 0 15px;
            border-radius: 10px;
            flex: 1;
            position: relative;
            overflow: hidden;
            text-align: center;
            // transform: scale(0.96);

            // &:hover {
            //     animation: zoom .8s ease forwards;
            // }

            &::before {
                content: '';
                position: absolute;
                height: 10px;
                width: 100%;
                top: 0px;
                left: 0px;
                width: 100%;
                background: $-text-300;
            }

            .title {
                font-size: 24px;
                font-weight: bold;
                line-height: 24px;
                color: $-text-950;
                margin-bottom: 16px;
            }

            p {
                font-size: 12px;
                line-height: 12px;
                color: $-text-500;
                margin-bottom: 40px;
            }

            b {
                font-size: 24px;
                font-weight: bold;
                color: $-text-950;
                line-height: 24px;
                display: block;
                margin-bottom: 40px;

                span {
                    font-size: 16px;
                }
            }

            ul {
                margin-top: 40px;

                li {
                    text-align: right;
                    position: relative;
                    line-height: 36px;
                    color: $-text-950;

                    label {
                        float: left;
                        color: $-text-600;
                    }
                }
            }

            &.active {
                &::before {
                    background: $--color-base;
                }
            }
        }
    }
}
</style>
